import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import api from '~/services/api';
import history from '~/services/history';
// Importando componentes
import Card from '~/components/Card';
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Select from '~/components/Form/Select';
import Textarea from '~/components/Form/Textarea';

import { Container } from './styles';

export default function Tentativas({ match }) {
  const inputRef = useRef(null);
  const [visibleAssunto, setVisibleAssunto] = useState(false);
  const [carregar, setCarregar] = useState(false);

  // Montando array do select tipo
  const tipos = [
    {
      label: 'Telefone',
      value: 'Telefone',
    },
    {
      label: 'Whatsapp',
      value: 'Whatsapp',
    },
    {
      label: 'E-mail',
      value: 'E-mail',
    },
  ];

  async function handlerSubmit(data) {
    try {
      setCarregar(true);
      const { id } = match.params;
      inputRef.current.setErrors({});

      const schema = Yup.object().shape({
        tentativa: Yup.string().required('Preencha o campo tentativa'),
        tipo: Yup.string('Selecione um tipo de tentativa').required(
          'Selecione um tipo de tentativa'
        ),
        instrucao: Yup.string().required('Preencha o campo instrução'),
        tempo: Yup.string().required('Preencha o campo tempo'),
        assunto: visibleAssunto
          ? Yup.string().required('Preencha o campo assunto')
          : null,
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      await api.post(`/cadencia/${id}/tentativa`, {
        tentativa: data.tentativa,
        tipo: data.tipo,
        instrucao: data.instrucao,
        tempo: data.tempo,
        assunto: visibleAssunto ? data.assunto : null,
      });

      toast.success('Tentativa criado com sucesso');
      history.push(`/cadencia-edit/${id}`);
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao criar tentativa, verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  function handlerChange(e) {
    if (e.value === 'E-mail') {
      setVisibleAssunto(true);
    } else {
      setVisibleAssunto(false);
    }
  }

  return (
    <Container>
      <h4>Cadastrar Tentativa</h4>
      <Card>
        <Form ref={inputRef} onSubmit={handlerSubmit} autoComplete="off">
          <Input
            icon="MdRepeat"
            label="Tentativa"
            name="tentativa"
            type="number"
          />
          <Select
            name="tipo"
            labelSelect="Tipo da tentativa"
            options={tipos}
            onChange={value => handlerChange(value)}
          />
          {visibleAssunto && (
            <Input icon="MdMail" label="Assunto" name="assunto" type="text" />
          )}
          <Textarea label="Instrução" name="instrucao" type="text" />
          <Input icon="MdAlarm" label="Tempo" name="tempo" type="number" />
          <Button tamanho="40px" load={carregar}>
            Cadastrar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}

Tentativas.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};
